import {
    BodyLargeEmphasized,
    Button,
    ButtonSize,
    ButtonVariant,
    XStack,
    YStack,
} from 'smoothie';

import { GroveSimpleModal } from './GroveSimpleModal';

interface ConfirmModalProps {
    isOpen: boolean;
    onClose: () => void;
    onConfirm: () => void;
    description?: string;
    yesText?: string;
    noText?: string;
}

export const ConfirmModal = ({
    isOpen,
    onClose,
    onConfirm,
    description = 'Are you sure?',
    yesText = 'Yes!',
    noText = 'Not quite',
}: ConfirmModalProps) => {
    return (
        <GroveSimpleModal isOpen={isOpen} onClose={onClose}>
            <YStack gap={36} width={480} maxWidth="90vw">
                <BodyLargeEmphasized alignSelf="center" textAlign="center">
                    {description}
                </BodyLargeEmphasized>
                <XStack
                    gap={24}
                    alignSelf="center"
                    flexWrap="wrap"
                    justifyContent="center"
                >
                    <Button
                        variant={ButtonVariant.SECONDARY}
                        size={ButtonSize.LARGE}
                        text={noText}
                        onPress={onClose}
                    />
                    <Button
                        variant={ButtonVariant.PRIMARY}
                        size={ButtonSize.LARGE}
                        tone="danger"
                        text={yesText}
                        onPress={onConfirm}
                    />
                </XStack>
            </YStack>
        </GroveSimpleModal>
    );
};
